import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useAppSelector } from "../../store/hooks";
import { selectSalesChartRawData } from "../../features/productAnalyzer/productAnalyzer.selector";
import { formatChartRawDataToSeriesPoints } from "../../helpers";
import { SALES_CHART_DEFAULT_OPTIONS } from "./lib/constants";
import { Box } from "@mui/material";
// import { selectIsFreePlan } from "../../features/pricingPlans/pricingPlans.selector";
// import useChartOverlay from "../../hooks/useChartOverlay";

type TRef = {
  chart?: Highcharts.Chart | null;
};

export const SalesChart = forwardRef<TRef>((_, ref) => {
  // const { overlayRenderer } = useChartOverlay();

  const [options, setOptions] = useState<Highcharts.Options>(
    SALES_CHART_DEFAULT_OPTIONS,
  );

  const chartRef = useRef<HighchartsReact.RefObject>(null);

  const { salesChartRawData } = useAppSelector(selectSalesChartRawData);
  // const isFreePlan = useAppSelector(selectIsFreePlan);

  useImperativeHandle(
    ref,
    () => ({
      chart: chartRef.current?.chart,
    }),
    [],
  );

  useEffect(() => {
    if (!salesChartRawData.length) return;

    const series = formatChartRawDataToSeriesPoints(
      SALES_CHART_DEFAULT_OPTIONS.series,
      salesChartRawData,
    );

    const newOptions = {
      ...SALES_CHART_DEFAULT_OPTIONS,
      series,
    };

    // if (isFreePlan) {
    //   newOptions.chart = {
    //     ...SALES_CHART_DEFAULT_OPTIONS.chart,
    //     events: {
    //       render(this: Highcharts.Chart) {
    //         overlayRenderer({
    //           chart: this,
    //           title: "Monthly Sold Chart",
    //         });
    //       },
    //     },
    //   };
    // }

    setOptions(newOptions);
  }, [salesChartRawData]);

  if (!salesChartRawData.length || !salesChartRawData[0].length) return null;

  return (
    <Box sx={{ position: "relative" }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />
    </Box>
  );
});

export default memo(SalesChart);
